module.exports = __webpack_public_path__ + "img/phase1.9e97ce56.png";